import React from 'react'
import {
	Box, Card, CardContent, Typography, Table, TableHead, TableBody, TableRow, TableCell,
	Grid, ToggleButton, ToggleButtonGroup
} from '@mui/material'
import { IconSeeker } from '@ui-seeker/core'


const DATES = ['15/03', '22/03', '01/04']
const WEEKS = ['Week -1', 'Week -2', 'Week -4']
const PROVIDERS = ['DrivePro', 'FleetMax', 'CarFirst']

const OFFICES = [
	{
		name: 'Madrid Barajas Airport',
		prices: {
			'15/03': {
				DrivePro:  [{ price: '€48.30', cheapest: false, expensive: false, evo: 'increase', diff: 3.2 }, { price: '€45.10', cheapest: true, expensive: false, evo: 'decrease', diff: 2.1 }, { price: '€52.80', cheapest: false, expensive: false, evo: null, diff: null }],
				FleetMax:  [{ price: '€42.50', cheapest: true, expensive: false, evo: 'decrease', diff: 5.4 }, { price: '€44.20', cheapest: false, expensive: false, evo: null, diff: null }, { price: '€46.90', cheapest: false, expensive: false, evo: 'increase', diff: 1.8 }],
				CarFirst:  [{ price: '€55.10', cheapest: false, expensive: true, evo: 'increase', diff: 8.1 }, { price: '€51.30', cheapest: false, expensive: false, evo: 'decrease', diff: 1.5 }, { price: '€58.40', cheapest: false, expensive: true, evo: 'increase', diff: 4.2 }],
			},
			'22/03': {
				DrivePro:  [{ price: '€52.10', cheapest: false, expensive: false, evo: 'increase', diff: 2.8 }, { price: '€49.80', cheapest: true, expensive: false, evo: 'decrease', diff: 3.5 }, { price: '€54.20', cheapest: false, expensive: false, evo: null, diff: null }],
				FleetMax:  [{ price: '€45.90', cheapest: true, expensive: false, evo: 'decrease', diff: 4.1 }, { price: '€47.30', cheapest: false, expensive: false, evo: null, diff: null }, { price: '€50.10', cheapest: false, expensive: false, evo: 'increase', diff: 2.3 }],
				CarFirst:  [{ price: '€59.80', cheapest: false, expensive: true, evo: 'increase', diff: 6.7 }, { price: '€56.20', cheapest: false, expensive: false, evo: null, diff: null }, { price: '€62.40', cheapest: false, expensive: true, evo: 'increase', diff: 3.9 }],
			},
			'01/04': {
				DrivePro:  [{ price: '€58.90', cheapest: false, expensive: false, evo: null, diff: null }, { price: '€55.40', cheapest: true, expensive: false, evo: 'decrease', diff: 4.2 }, { price: '€61.70', cheapest: false, expensive: false, evo: 'increase', diff: 1.9 }],
				FleetMax:  [{ price: '€50.20', cheapest: true, expensive: false, evo: 'decrease', diff: 6.3 }, { price: '€52.80', cheapest: false, expensive: false, evo: 'increase', diff: 1.1 }, { price: '€55.40', cheapest: false, expensive: false, evo: null, diff: null }],
				CarFirst:  [{ price: '€65.30', cheapest: false, expensive: true, evo: 'increase', diff: 9.2 }, { price: '€61.10', cheapest: false, expensive: false, evo: null, diff: null }, { price: '€68.50', cheapest: false, expensive: true, evo: 'increase', diff: 5.1 }],
			},
		},
	},
	{
		name: 'Barcelona El Prat',
		prices: {
			'15/03': {
				DrivePro:  [{ price: '€51.20', cheapest: false, expensive: false, evo: 'increase', diff: 2.1 }, { price: '€48.90', cheapest: true, expensive: false, evo: 'decrease', diff: 3.8 }, { price: '€54.60', cheapest: false, expensive: false, evo: null, diff: null }],
				FleetMax:  [{ price: '€44.80', cheapest: true, expensive: false, evo: 'decrease', diff: 4.7 }, { price: '€46.50', cheapest: false, expensive: false, evo: null, diff: null }, { price: '€49.20', cheapest: false, expensive: false, evo: 'increase', diff: 2.5 }],
				CarFirst:  [{ price: '€57.90', cheapest: false, expensive: true, evo: 'increase', diff: 7.3 }, { price: '€54.10', cheapest: false, expensive: false, evo: 'decrease', diff: 2.0 }, { price: '€61.30', cheapest: false, expensive: true, evo: 'increase', diff: 5.6 }],
			},
			'22/03': {
				DrivePro:  [{ price: '€55.40', cheapest: false, expensive: false, evo: null, diff: null }, { price: '€52.10', cheapest: true, expensive: false, evo: 'decrease', diff: 2.9 }, { price: '€57.80', cheapest: false, expensive: false, evo: 'increase', diff: 1.4 }],
				FleetMax:  [{ price: '€48.30', cheapest: true, expensive: false, evo: 'decrease', diff: 3.6 }, { price: '€50.70', cheapest: false, expensive: false, evo: 'increase', diff: 0.8 }, { price: '€53.10', cheapest: false, expensive: false, evo: null, diff: null }],
				CarFirst:  [{ price: '€62.50', cheapest: false, expensive: true, evo: 'increase', diff: 5.9 }, { price: '€58.90', cheapest: false, expensive: false, evo: null, diff: null }, { price: '€65.80', cheapest: false, expensive: true, evo: 'increase', diff: 4.3 }],
			},
			'01/04': {
				DrivePro:  [{ price: '€61.80', cheapest: false, expensive: false, evo: 'increase', diff: 3.4 }, { price: '€58.20', cheapest: true, expensive: false, evo: 'decrease', diff: 5.1 }, { price: '€64.50', cheapest: false, expensive: false, evo: null, diff: null }],
				FleetMax:  [{ price: '€53.70', cheapest: true, expensive: false, evo: 'decrease', diff: 7.2 }, { price: '€55.90', cheapest: false, expensive: false, evo: null, diff: null }, { price: '€58.30', cheapest: false, expensive: false, evo: 'increase', diff: 2.0 }],
				CarFirst:  [{ price: '€68.40', cheapest: false, expensive: true, evo: 'increase', diff: 8.5 }, { price: '€64.70', cheapest: false, expensive: false, evo: 'decrease', diff: 1.3 }, { price: '€71.90', cheapest: false, expensive: true, evo: 'increase', diff: 6.1 }],
			},
		},
	},
]

function PriceBox({ data }) {
	const borderColor = data.cheapest ? 'success.main' : data.expensive ? 'error.main' : 'secondary.light'
	const bgColor = data.cheapest ? 'rgba(46,125,50,0.1)' : data.expensive ? 'rgba(211,47,47,0.1)' : 'rgba(0,0,0,0.03)'

	return <Box sx={{
		border: 2, borderColor, backgroundColor: bgColor,
		borderRadius: 1, textAlign: 'center', py: 0.5, px: 0.5, minWidth: 75,
	}}>
		<Typography sx={{ fontWeight: 700, fontSize: '0.78rem' }}>{data.price}</Typography>
		{data.evo && <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.3, mt: 0.3 }}>
			<IconSeeker
				icon={data.evo === 'increase' ? 'arrow-up' : 'arrow-down'}
				sx={{ fontSize: 11, color: data.evo === 'increase' ? 'success.dark' : 'error.main' }}
			/>
			<Typography sx={{ fontSize: '0.62rem', color: data.evo === 'increase' ? 'success.dark' : 'error.main' }}>
				{data.diff}%
			</Typography>
		</Box>}
	</Box>
}


export default function PricingEnvironmentDemoData() {
	return <Grid container spacing={2}>
		<Grid item xs={12}>
			<Card>
				<CardContent sx={{ p: 2 }}>
					<Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
						<Typography variant="subtitle1" fontWeight={600}>Pricing Environment</Typography>
						<ToggleButtonGroup size="small" value="min" exclusive>
							<ToggleButton value="min" sx={{ px: 2, py: 0.5, textTransform: 'none', fontSize: '0.75rem' }}>Min. Price</ToggleButton>
							<ToggleButton value="avg" sx={{ px: 2, py: 0.5, textTransform: 'none', fontSize: '0.75rem' }}>Avg. Price</ToggleButton>
							<ToggleButton value="max" sx={{ px: 2, py: 0.5, textTransform: 'none', fontSize: '0.75rem' }}>Max. Price</ToggleButton>
						</ToggleButtonGroup>
					</Box>

					<Box sx={{ overflowX: 'auto' }}>
						<Table size="small">
							<TableHead>
								{/* Top header: Office/Providers + dates */}
								<TableRow sx={{ '& th': { bgcolor: 'primary.main', color: 'white', fontWeight: 600, fontSize: '0.72rem', textAlign: 'center', borderBottom: 0 } }}>
									<TableCell rowSpan={2} sx={{ minWidth: 200, position: 'sticky', left: 0, zIndex: 3, bgcolor: 'primary.main' }}>
										<Box sx={{ display: 'flex' }}>
											<Typography sx={{ flex: 1, fontWeight: 700, fontSize: '0.72rem', color: 'white' }}>Branch</Typography>
											<Typography sx={{ flex: 1, fontWeight: 700, fontSize: '0.72rem', color: 'white' }}>Providers</Typography>
										</Box>
									</TableCell>
									{DATES.map(date => (
										<TableCell key={date} colSpan={WEEKS.length} sx={{ textAlign: 'center' }}>
											{date}
										</TableCell>
									))}
								</TableRow>
								{/* Sub header: booking weeks */}
								<TableRow sx={{ '& th': { bgcolor: 'primary.dark', color: 'white', fontWeight: 600, fontSize: '0.68rem', textAlign: 'center' } }}>
									{DATES.map(date =>
										WEEKS.map(week => (
											<TableCell key={`${date}-${week}`}>{week}</TableCell>
										))
									)}
								</TableRow>
							</TableHead>
							<TableBody>
								{OFFICES.map((office, oi) =>
									PROVIDERS.map((provider, pi) => (
										<TableRow key={`${oi}-${pi}`} sx={{ '& td': { py: 0.8 } }}>
											{pi === 0 && (
												<TableCell
													rowSpan={PROVIDERS.length}
													sx={{
														bgcolor: 'primary.main', color: 'white',
														position: 'sticky', left: 0, zIndex: 2,
														verticalAlign: 'top', borderBottom: 2, borderColor: 'primary.dark',
													}}
												>
													<Box sx={{ display: 'flex' }}>
														<Typography sx={{ flex: 1, fontWeight: 600, fontSize: '0.75rem', color: 'white' }}>
															{office.name}
														</Typography>
														<Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 1.5 }}>
															{PROVIDERS.map((p, i) => (
																<Typography key={i} sx={{ fontWeight: 600, fontSize: '0.72rem', color: 'white' }}>{p}</Typography>
															))}
														</Box>
													</Box>
												</TableCell>
											)}
											{DATES.map(date =>
												WEEKS.map((week, wi) => {
													const data = office.prices[date]?.[provider]?.[wi]
													return <TableCell key={`${date}-${week}-${provider}`} sx={{ textAlign: 'center', p: 0.5 }}>
														{data ? <PriceBox data={data} /> : <Typography sx={{ color: 'secondary.lighter', fontSize: '0.75rem' }}>N/A</Typography>}
													</TableCell>
												})
											)}
										</TableRow>
									))
								)}
							</TableBody>
						</Table>
					</Box>
				</CardContent>
			</Card>
		</Grid>
	</Grid>
}
